/** Volume helpers shared by the game audio and the voice playback. */

/** Clamps to 0..1; NaN counts as 0. */
export function clamp01(value: number): number {
  if (!(value > 0)) return 0;
  return value < 1 ? value : 1;
}

/**
 * Gain for a 0..1 volume slider. Loudness is perceived roughly logarithmically, so a linear
 * slider would do almost nothing in its upper half; squaring it is the usual "audio taper".
 */
export function volumeToGain(volume: number): number {
  const v = clamp01(volume);
  return v * v;
}

/** Linear amplitude to dBFS (-Infinity for silence). */
export function toDb(amplitude: number): number {
  return amplitude > 0 ? 20 * Math.log10(amplitude) : Number.NEGATIVE_INFINITY;
}

/** RMS level of a block of samples in dBFS. */
export function rmsDb(samples: Float32Array): number {
  let sum = 0;
  for (let i = 0; i < samples.length; i++) {
    const sample = samples[i] ?? 0;
    sum += sample * sample;
  }
  return samples.length === 0 ? Number.NEGATIVE_INFINITY : toDb(Math.sqrt(sum / samples.length));
}
